<svg width="13" height="14" viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="6.19995" cy="7" r="4.5" fill="#F5FA74" stroke="#121F3A"/>
</svg>
